import { Component, Input, OnInit } from '@angular/core';
import { ISideBarButtons } from '../../interfaces/ISidebarMenu';
import { SidebarButtonDirective } from '../buttons/sidebar-button/sidebar-button.component';
import { CommonModule } from '@angular/common';
import { Overview } from '../../abstract/Overview';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'left-sidebar-menu',
  standalone: true,
  imports: [CommonModule, SidebarButtonDirective, MatButtonModule],
  templateUrl: './left-sidebar-menu.component.html',
  styleUrl: './left-sidebar-menu.component.scss'
})
export class LeftSidebarMenuComponent extends Overview implements OnInit{
  ngOnInit(): void {
    this.isOverviewActive = true;
  }
  @Input() sideBarButtonsTop!: ISideBarButtons[];
  @Input() sideBarButtonsBottom!: ISideBarButtons[];

  isButtonActive(sidebarButton: ISideBarButtons) {
    return !sidebarButton.disabled && !!sidebarButton.isActive?.();
  }
}
